/**
 * Work out the perpendicular line distance
 * @returns Number
 */
export function perpendicularLineDistance(marker) {
  return lineDistance(marker.intersectionX, marker.intersectionY, marker.curveX, marker.curveY);
}

/**
 * Work out the main line distance
 * @returns Number
 */
export function regularLineDistance(marker) {
  return lineDistance(marker.x1, marker.y1, marker.x2, marker.y2);
}

/**
 * Work out line distance between two points
 * @returns Number
 */
function lineDistance(startX, startY, endX, endY) {
  return Math.hypot(endX - startX, endY - startY);
}

/**
 * Determines whether the perpendicular intersection point is on the main line
 * @returns true/false
 */
export function pointOnMainLine(marker, x, y) {
  const distance = Math.hypot(x - marker.x1, y - marker.y1) + Math.hypot(x - marker.x2, y - marker.y2);

  return Math.abs(distance - regularLineDistance(marker)) <= 0.1;
}
